import React from 'react';
import { Accordion } from 'flowbite-react';
import Image from 'next/image';

const SupplyChainKeyFocus = () => {
    return (
        <div className="section-py bg-grey">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 pb-30">
                    <div className="lg:col-span-9">
                        <p
                            className="text-primary mb-2.5 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Key Focus Areas to Consider
                        </p>
                        <h2 className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Developing Effective Strategies for Supply Chain Management Software
                        </h2>
                    </div>
                </div>
                <div className="row items-center grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <Accordion>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Enterprise Solutions
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        We build robust platforms designed to support large-scale operations. Whether you manage
                                        multiple warehouses, vendors, or global teams, your system will handle it all with
                                        consistency and speed.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Artificial Intelligence
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        AI powers everything from smarter demand forecasting to real-time decision-making. We
                                        embed machine learning into your workflows to reduce guesswork and increase operational
                                        accuracy.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Technology Integration
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        We connect your core systems—ERP, CRM, WMS, and TMS—into a unified environment. This
                                        ensures seamless data flow, better coordination, and full supply chain visibility.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    BI and Analytics
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        Our platforms include interactive dashboards and advanced analytics to help you monitor
                                        performance, spot inefficiencies, and act on insights with confidence.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Digital Commerce
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        We enable smooth coordination between your digital sales channels and physical operations.
                                        This means faster order fulfillment, accurate inventory updates, and happier customers.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title as="h3" className="accordion-title">
                                    Business Automation
                                </Accordion.Title>
                                <Accordion.Content className="accordion-border">
                                    <div className="fs-md mb-0 text-secondary">
                                        We automate routine supply chain processes like procurement approvals, shipment tracking,
                                        and invoice matching. This speeds up operations and reduces manual errors.
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                        </Accordion>
                    </div>
                    <div className="lg:col-span-6 text-center">
                        <Image
                            src="/img/img-key-focus-area-2x.webp"
                            alt="key-focus-area"
                            title="key-focus-area"
                            className="img-fluid"
                            height={468}
                            width={595}
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SupplyChainKeyFocus;
